import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout/layout.component';
import { LoginComponent } from './auth/login/login.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { EmailVerifyComponent } from './auth/email-verify/email-verify.component';
import { EmailResetPasswordComponent } from './auth/email-reset-password/email-reset-password.component';
import { SignUpComponent } from './auth/signup/signup.component';
import { AuthGuard } from './services/auth.guard';
import { HeaderNewComponent } from './layouts/header-new/header-new.component';
import { NotLoggedInComponent } from './auth/not-logged-in/not-logged-in.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MicrosoftCallbackComponent } from './auth/microsoft-callback/microsoft-callback.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'header',
    component: HeaderNewComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Termhub - Log in' },
  },
  {
    path: 'home',
    component: NotLoggedInComponent,
    data: { title: 'Termhub' },
  },
  {
    path: 'signup',
    component: SignUpComponent,
    data: { title: 'Termhub - Sign Up' },
  },
  {
    path: 'email-verify',
    component: EmailVerifyComponent,
    data: { title: 'Termhub - Verify Email' },
  },
  {
    path: 'email-reset-password',
    component: EmailResetPasswordComponent,
    data: { title: 'Termhub - Reset Password' },
  },
  {
    path: 'password-reset',
    component: PasswordResetComponent,
    data: { title: 'Termhub - Reset Password' },
  },
  {
    path: 'password-reset/:username/:token',
    component: PasswordResetComponent,
    data: { title: 'Termhub - Reset Password' },
  },
  {
    path: 'auth/microsoft/callback',
    component: MicrosoftCallbackComponent,
    data: { title: 'Termhub - Microsoft login' },
  },
  {
    path: '**',
    component: DashboardComponent,
    data: { title: 'Termhub - Dashboard', error: true },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'ignore',
      urlUpdateStrategy: 'eager',
      scrollPositionRestoration: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
